import { Col, Row } from "react-bootstrap";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "src/components/Shared/NewForms/NFTextAreaInput";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

const CommodityWaybillsDetailAdditional = () => {
  return (
    <>
      <Row>
        <Col sm={12}>
          <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
        </Col>
      </Row>
    </>
  );
};

export default CommodityWaybillsDetailAdditional;
